/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomDefinitionsFilter {
    getFixupPrototypeFunction() { return AppSecopsSbomDefinitionsFilter.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomDefinitionsFilter>): AppSecopsSbomDefinitionsFilter {
        let obj = Object.assign(new AppSecopsSbomDefinitionsFilter(), model);
        AppSecopsSbomDefinitionsFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomDefinitionsFilter>): AppSecopsSbomDefinitionsFilter {
        if (!model) return null;
        return AppSecopsSbomDefinitionsFilter.newInstance(<AppSecopsSbomDefinitionsFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomDefinitionsFilter) {
        if (!obj) return;

        models.AppSecopsSbomDefinitionsFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomDefinitionsFilter): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomDefinitionsFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Search based on name
     */
    search: string;

    /**
     * Filter based on portfolio_id, application_id, appsecops_project_id
     */
    filters: models.QueryOperator;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
